import { useCopiedState } from "../../../../core/util/hooks";
import { PortfolioFilter } from "../types";
import { setFilter, removeFilter, initialState } from "../portfolioUXSlice";
import { invalidatePortfolio } from "../portfolioDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";

export const usePortfolioFilter = () => {
	const [storeFilter] = useCurrentPortfolioFilter();
	const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<PortfolioFilter>(storeFilter, true);

	const dispatch = useDispatch();
	const dispatchSetFilter = React.useCallback(() => {
		dispatch(setFilter(filter!));
		dispatch(invalidatePortfolio());
	}, [dispatch, filter]);

	const dispatchResetFilter = React.useCallback(() => {
		setCurrentFilter(initialState.filter)
	}, [setCurrentFilter]);

	return [filter, editFilter, dispatchSetFilter, changeState, dispatchResetFilter] as [
		typeof filter,
		typeof editFilter,
		typeof dispatchSetFilter,
		typeof changeState,
		typeof dispatchResetFilter
	];
};

export const useCurrentPortfolioFilter = () => {
	const filter = useSelector<StoreType, PortfolioFilter>(store => store.ux.domestic.portfolio.filter);
	const dispatch = useDispatch();
	const dispatchRemoveFilter = React.useCallback(
		(type: keyof PortfolioFilter) => {
			dispatch(removeFilter(type));
			dispatch(invalidatePortfolio());
		},
		[dispatch]
	);

	return [filter, dispatchRemoveFilter] as [typeof filter, typeof dispatchRemoveFilter];
};
